import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import InfoBar from './components/InfoBar';
import PresidentMessageSection from './components/PresidentMessageSection';
import GlobalCollaborationSection from './components/GlobalCollaborationSection';
import AboutBiharSection from './components/AboutBiharSection';
// import InteractiveCardsSection from './components/InteractiveCardsSection';
import RegistrationSection from './components/RegistrationSection';
import SpeakersSection from './components/SpeakersSection';
// import PartnersSection from './components/PartnersSection';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <InfoBar />
        <PresidentMessageSection />
        <GlobalCollaborationSection />
        <AboutBiharSection />
        {/* <InteractiveCardsSection /> */}
        <RegistrationSection />
        <SpeakersSection />
        {/* <PartnersSection /> */}
      </main>
      <Footer />
    </>
  );
}

export default App;
